import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { AdditionalFields } from '../common.types';
import { getDateModified, getRoleForMutation } from '../../utilities/utilityFunctions';
import { defaultDoc, getValueFromLocalStorage } from '../share/defaultDoc';
import type { SavepmChecklist, SavePmChecklistDocument } from './savepmChecklist.types';

export const savePmChecklistPullQueryBuilder = (document: SavepmChecklist) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = { ...defaultDoc };
  }

  const query = print(gql`
    query mobileAssetInspectionPMChecklistsInfo(
      $siteId: Int!
      $disciplineId: Int!
      $lastRequested: DateTime!
      $isLeadInspector: Boolean!
    ) {
      mobileAssetInspectionPMChecklistsInfo(
        siteId: $siteId
        disciplineId: $disciplineId
        lastRequested: $lastRequested
        isLeadInspector: $isLeadInspector
      ) {
        inspectionId
        assetCategoryInspectionTypeCheckListId
        isCompleted
        comments
        dateCreated
        dateModified
        createdBy
        modifiedBy
        isActive
        pk_uuid
        pkAssetInspectionPMChecklist
        site
        discipline
        inspectorId
        fkAssetInspectionTask
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
      disciplineId: JSON.parse(getValueFromLocalStorage('selectedDiscipline'))
        ?.selectedDisciplineId,
      lastRequested: getDateModified(
        doc?.dateModified,
        doc?.dateCreated,
        doc.site,
        doc.discipline,
        JSON.parse(getValueFromLocalStorage('selectedSite'))?.selectedSiteId,
        JSON.parse(getValueFromLocalStorage('selectedDiscipline'))?.selectedDisciplineId,
      ),
      isLeadInspector: getValueFromLocalStorage('isLeadInspector') === 'True',
    },
  };
};

export const savePmChecklistPushQueryBuilder = (doc: SavePmChecklistDocument[]) => {
  const document = doc[0];
  const query = print(gql`
    mutation saveUpdateMobileAssetInspectionPMChecklist(
      $role: Int!
      $AssetInspectionPMChecklistInput: AssetInspectionPMChecklistInput
    ) {
      saveUpdateMobileAssetInspectionPMChecklist(
        role: $role
        assetInspectionPMChecklist: $AssetInspectionPMChecklistInput
      ) {
        id
        pk_uuid
        status
      }
    }
  `);

  const role = getRoleForMutation(document);

  const variables = {
    role,
    AssetInspectionPMChecklistInput: document,
  };
  return {
    query,
    variables,
  };
};

export const savePmChecklistPushModifier = (doc: SavePmChecklistDocument) => {
  const obj: SavePmChecklistDocument &
    AdditionalFields & { pkAssetInspectionPMChecklist?: number } = {
    ...doc,
  };
  if (obj.pkAssetInspectionPMChecklist === 0) {
    obj.pkAssetInspectionPMChecklist = undefined;
  }
  const blackListedProp = [
    '_attachments',
    '_rev',
    '_deleted',
    'site',
    'discipline',
    'inspectorId',
    '_meta',
    'isDeleted',
  ];
  blackListedProp.forEach(property => {
    obj[property as keyof AdditionalFields] = undefined;
  });
  return obj;
};
